/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityNotificationsOrderBy = {
    EntityId: 'entity_id',
    NotificationMedia: 'notification_media',
    NotificationRecipient: 'notification_recipient',
    Recipient: 'recipient',
    Status: 'status',
    StatusExternal: 'status_external',
    Reason: 'reason',
    SentAt: 'sent_at',
    Created: 'created'
} as const;
export type MonitEntityNotificationsOrderBy = typeof MonitEntityNotificationsOrderBy[keyof typeof MonitEntityNotificationsOrderBy];


export function MonitEntityNotificationsOrderByFromJSON(json: any): MonitEntityNotificationsOrderBy {
    return MonitEntityNotificationsOrderByFromJSONTyped(json, false);
}

export function MonitEntityNotificationsOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityNotificationsOrderBy {
    return json as MonitEntityNotificationsOrderBy;
}

export function MonitEntityNotificationsOrderByToJSON(value?: MonitEntityNotificationsOrderBy | null): any {
    return value as any;
}

